<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="600px"
  >
    <v-card>
      <v-card-text>
        <v-container>
          <v-form
            ref="formNewCliente"
            lazy-validation
            @submit.prevent="save()"
          >
            <v-card-title class="pa-2">
              {{ isEdit ? 'Modificar operario' : 'Registrar operario' }}
              <v-spacer />
            </v-card-title>

              <v-text-field
                v-model="nombre_comercial"
                class="px-2 py-1"
                flat
                label="Nombre"
                outlined
                :rules="[v => !!v || 'El nombre es obligatorio']"
                required
              />

              <v-text-field
                v-model="ubicacion"
                label="DNI"
                class="px-2 py-1"
                flat
                required
                :rules="[v => !!v || 'El dni es obligatorio']"
                outlined
              />

            <v-row no-gutters>
              <v-col cols="6">
                <v-text-field
                    v-model="ubicacion"
                    label="DNI"
                    class="px-2 py-1"
                    flat
                    required
                    :rules="[v => !!v || 'El dni es obligatorio']"
                    outlined
                />
              </v-col>

              <v-col cols="6">
                <v-text-field
                    v-model="ubicacion"
                    label="Celular"
                    class="px-2 py-1"
                    flat
                    required
                    :rules="[v => !!v || 'El celular es obligatorio']"
                    outlined
                />
              </v-col>

                <v-col cols="6">
                <v-text-field
                    v-model="ubicacion"
                    label="Correo"
                    class="px-2 py-1"
                    flat
                    required
                    :rules="[v => !!v || 'El correo es obligatorio']"
                    outlined
                />
              </v-col>

              <v-col cols="6">
                <v-select
                  v-model="tipo_de_cliente"
                  class="px-2 py-1"
                  flat
                  label="Seleccione tipo de trabajador"
                  :items="['CARPINTERO', 'DRYWALERO']"
                  required
                  :rules="[v => !!v || 'El tipo de cliente es obligatorio']"
                  outlined
                />
              </v-col>
              <!-- <v-col cols="6">
              <v-select
                v-model="canales_de_venta"
                class="px-2 py-1"
                outlined  
                flat
                :items="canales_de_ventas"
                label="Seleccione canal de venta"
                :rules="[v => !!v || 'Seleccionar canal de venta es obligatorio']"
                required
              />
              </v-col> -->

              <v-col cols="6">
                <v-select
                  v-model="departamento"
                  class="px-2 py-1"
                  outlined
                  flat
                  :items="departamentos"
                  label="Seleccione departamento fiscal"
                  :rules="[v => !!v || 'Seleccionar departamento fiscal es obligatorio']"
                  @change="onChangeRegion"
                />
              </v-col>
              <v-col cols="6">
              <v-select
                v-model="provincia"
                class="px-2 py-1"
                outlined
                flat
                :items="provincias"
                label="Seleccione la provincia Fiscal (Excepto region Lima, Seleccione distrito)"
                :rules="[v => !!v || 'Seleccionar la provincia Fiscal es obligatorio']"
              />
              </v-col>

              <!-- <v-col cols="6">
              <v-select
                v-if="isAdmin && isEdit"
                v-model="email"
                class="px-2 py-1"
                outlined
                flat
                :items="users"
                label="Usuario a cargo"
              />
                @change="getUserByEmail"
              </v-col> -->

            </v-row>

            <v-card-actions class="pa-2">
              <v-btn
                outlined
                @click="close"
              >
                Cancelar
              </v-btn>
              <v-spacer />
              <v-btn
                color="primary"
                type="submit"
                :loading="loading"
              >
                Guardar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>

    <v-snackbar
      v-model="snackbar"
    >
    {{ snackbarTxt }}
  </v-snackbar>

  </v-dialog>
            <!-- </v-card-text> -->
</template>

<script>
  // import { doc, setDoc, Timestamp } from 'firebase/firestore'
  // import axios from 'axios'

  export default {
    data () {
      return {
        cliente: undefined,
        departamentos: [],
        provincias: [],
        tipos_de_clientes: [],
        canales_de_ventas: [],
        loading: false,
        nombre_comercial: '',
        tipo_de_cliente: '',
        ubicacion: '',
        canales_de_venta: '',
        dialog: false,
        departamento: '',
        provincia: '',
        snackbar: false,
        snackbarTxt: '',
      }
    },
    computed: {
      isEdit () {
        return this.cliente === undefined ? false : 'qw'
      },
      isAdmin () {
        return JSON.parse(localStorage.userAuth).perfil !== 'Administrador' ? false : 'a'
      },
    },
    mounted () {
      this.tipos_de_clientes = this.$store.state.tipo_de_cliente_distribuidores
      this.canales_de_ventas = this.$store.state.canales_de_venta_distribuidores
      this.getDepartamentos()
    },
    methods: {
      async open (cliente) {
        this.dialog = true
        this.cliente = cliente
        if (this.isEdit) {
            this.nombre_comercial = cliente.nombre_comercial
            this.ubicacion = cliente.ubicacion
            this.canales_de_venta = cliente.canales_de_venta
            this.tipo_de_cliente = cliente.tipo_de_cliente
            this.departamento = this.cliente.departamento
            // this.provincia = this.cliente.provincia
          if (cliente?.departamento) {
            this.departamento = cliente?.departamento
          }
          if (cliente?.provincia) {
            this.provincia = cliente?.provincia.trim()
            var privinciaSeleccionadaByFiltro = await this.$store.state.regiones.filter(region => region.NOMBRE === cliente?.departamento)
            this.provincias = privinciaSeleccionadaByFiltro[0]?.PROVINCIAS
          }
        }
      },
      close () {
        this.$refs.formNewCliente.reset()
        this.dialog = false
        this.loading = false
      },
      getDepartamentos () {
        this.departamentos = []
        this.$store.state.regiones.forEach(region => {
          this.departamentos.push(region.NOMBRE)
        })
      },
      onChangeRegion () {
        var privinciaSeleccionadaByFiltro = this.$store.state.regiones.filter(region => region.NOMBRE === this.departamento)
        this.provincias = privinciaSeleccionadaByFiltro[0].PROVINCIAS
      },
      async save () {
        if (this.$refs.formNewCliente.validate() && this.isEdit === false) {
          this.loading = true
          const payload = {
            nombre_comercial: this.nombre_comercial,
            tipo_de_cliente: this.tipo_de_cliente,
            ubicacion: this.ubicacion,
            canales_de_venta: this.canales_de_venta,
            departamento: this.departamento,
            provincia: this.provincia,
          }

          const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/distribuidores/prospectar',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(payload)
            })

          const data = await response.json()
          if (data.success) {
              this.loading = false
              this.close()
              this.$emit('onCreateCliente')
            } else {
              this.snackbar = true
              this.snackbarTxt = 'No se pudo crear cliente'
              this.loading = false
            }
        } else {
          if (this.$refs.formNewCliente.validate() && this.isEdit) {
            this.loading = true

            const payload = {
              nombre_comercial: this.nombre_comercial,
              tipo_de_cliente: this.tipo_de_cliente,
              ubicacion: this.ubicacion,
              canales_de_venta: this.canales_de_venta,
              departamento: this.departamento,
              provincia: this.provincia,
            }

            const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/distribuidores/prospectar/' + this.cliente.id,
              {
                method: 'PUT',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
              })
            const data = await response.json()
            if (data.success) {
              this.loading = false
              this.close()
              this.$emit('onCreateCliente')
            } else {
              this.snackbar = true
              this.snackbarTxt = 'La no se pudo modificar los datos del cliente'
              this.loading = false
            }
          }
        }
      },
    },

  }
</script>

<style>
</style>
